"use strict";

var _interopRequireDefault = require("/app/node_modules/.pnpm/@babel+runtime@7.25.6/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _debounce = _interopRequireDefault(require("lodash/debounce"));
var _default = exports.default = {
  name: 'YsTableLayout',
  provide() {
    return {
      getScrollY: () => this.scrollY
    };
  },
  props: {
    searchBarClass: {
      type: String,
      default: ''
    },
    tableWrapperClass: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      resizeObserver: undefined,
      scrollY: ''
    };
  },
  mounted() {
    this.initResizeObserver();
  },
  updated() {
    this.$nextTick(() => {
      this.debounceUpdateScrollY();
    });
  },
  beforeDestroy() {
    const unobserve = element => {
      if (!element) return;
      this.resizeObserver?.unobserve(element);
    };
    const {
      tableLayout,
      searchWrapper,
      tableWrapper
    } = this.$refs;
    unobserve(tableLayout);
    unobserve(searchWrapper);
    unobserve(tableWrapper);
  },
  methods: {
    initResizeObserver() {
      const resizeObserver = this.resizeObserver = new ResizeObserver(() => {
        this.debounceUpdateScrollY();
      });
      const {
        tableLayout,
        searchWrapper,
        tableWrapper
      } = this.$refs;
      const observe = element => {
        if (!element) return;
        resizeObserver.observe(element);
      };
      observe(tableLayout);
      observe(searchWrapper);
      observe(tableWrapper);
    },
    updateScrollY() {
      const tableWrapper = this.$refs.tableWrapper;
      const antTableEl = tableWrapper?.querySelector('.ant-table');
      const searchWrapper = this.$refs.searchWrapper;
      const searchHeight = searchWrapper?.offsetHeight ?? 0;
      const layout = this.$refs.tableLayout;
      const layoutStyle = window.getComputedStyle(layout);
      const layoutHeight = layout.clientHeight - parseFloat(layoutStyle.paddingTop) - parseFloat(layoutStyle.paddingBottom);
      const tableWrapperHeight = layoutHeight - searchHeight;
      tableWrapper.style.height = `${tableWrapperHeight}px`;
      this.$emit('update-size');
      if (!antTableEl) {
        return;
      }
      const tableWrapperStyle = window.getComputedStyle(tableWrapper);
      const toolbarEl = tableWrapper.querySelector('.header');
      const toolbarHeight = toolbarEl?.offsetHeight ?? 0;
      const ysTableEl = tableWrapper.querySelector('.ys-table');
      const ysTableStyle = window.getComputedStyle(ysTableEl);
      const targetBodyHeight = tableWrapperHeight - parseFloat(tableWrapperStyle.paddingBottom) - parseFloat(tableWrapperStyle.paddingTop) - toolbarHeight - parseFloat(ysTableStyle.paddingTop) - parseFloat(ysTableStyle.paddingBottom);
      const antTableTitleEl = antTableEl.querySelector('.ant-table-title');
      const antTableTitleHeight = antTableTitleEl?.offsetHeight ?? 0;
      const antTableFooterEl = antTableEl.querySelector('.ant-table-footer');
      const antTableFooterHeight = antTableFooterEl?.offsetHeight ?? 0;
      const antTableHeaderEl = antTableEl.querySelector('.ant-table-thead');
      const antTableHeaderHeight = antTableHeaderEl?.offsetHeight ?? 0;
      const paginationEl = tableWrapper.querySelector('.pagination');
      const paginationHeight = paginationEl?.offsetHeight ?? 0;
      const visualPaginationEl = tableWrapper.querySelector('.ant-table-pagination');
      let visualPaginationHeight = visualPaginationEl?.offsetHeight ?? 0;
      if (visualPaginationEl) {
        const visualPaginationStyle = window.getComputedStyle(visualPaginationEl);
        visualPaginationHeight = visualPaginationHeight + parseFloat(visualPaginationStyle.marginTop) + parseFloat(visualPaginationStyle.marginBottom);
      }
      this.scrollY = targetBodyHeight - antTableTitleHeight - antTableFooterHeight - antTableHeaderHeight - paginationHeight - visualPaginationHeight;
    }
  },
  created() {
    this.debounceUpdateScrollY = (0, _debounce.default)(this.updateScrollY, 500);
  }
};